export enum ServiceStatus {
  None = 0,
  Inspection = 1,
  Repair = 2,
  Replacement = 3,
}

export interface StatusDisplay {
  label: string;
  tag: string;
}

export interface Permissions {
  bRepairs_User_Save: boolean;
  bRepairs_User_Edit: boolean;
  bRepairs_User_Delete: boolean;
}

export interface RawRepair {
  iRepairMaintenanceRecord: number;
  strDate?: string;
  strUserSaved?: string;
  strRepairman?: string;
  strReason?: string;
  strComment?: string;
  strImage?: string;
  iKM?: number | string | null;
  iTotalCost?: number | string | null;
  ISSessionExpired?: boolean;
}

export interface RepairRow extends RawRepair {
  searchIndex: string;
  cost: number;
  costText: string;
  kmText: string;
}

export interface ServiceItem {
  iRepairMaintenanceType: number;
  strTitle: string;
  iCost: string | number;
  strComment: string;
  tiStatus: ServiceStatus;
  bExpanded: boolean;
}

export interface RepairType {
  iRepairMaintenanceType: number;
  strComment: string;
}

export interface RepairFilters {
  fromDate?: string;
  toDate?: string;
  repairer?: string;
  reason?: string;
}
